import React from "react";
import {Heading, List, ListItem, Stack, Text} from "@chakra-ui/react";

export const BlogPost3 = () => {
    return (
        <Stack spacing={3}>
            <Text>While trees often add beauty and value to your home and property there are times when a tree can
                actually be hazardous, making tree removal a necessity. The tree removal process is complex and often
                best done by a team of professionals.</Text>
            <Heading as="h2" fontSize={'xl'}>To know whether or not tree removal is necessary, you must take a look at the following
                things:</Heading>
            <List styleType="disc">
                <ListItem>
                    <b>Safety:</b> Dead or dying trees can pose major risks to your property and can be hazardous to
                    anyone on it as well. If a tree is diseased or structurally unsound, it can fall and cause major
                    problems for you as a homeowner. Removing such trees is essential to mitigate the risk of property
                    damage and personal injury. A professional arborist can assess the health and stability of trees and
                    recommend removal when necessary to ensure the safety of your property and its occupants.
                </ListItem>
                <ListItem>
                    <b>Disease Control:</b> Removing a diseased tree can prevent the spread of disease to other plants
                    or parts of your yard. Diseased trees can serve as a source of infection for neighboring trees,
                    shrubs, and vegetation, leading to widespread damage and loss. Timely removal of infected trees
                    helps contain the spread of disease and preserve the health of your landscape.
                </ListItem>
                <ListItem>
                    <b>Aesthetics:</b> There are instances where a tree might actually block a view or cut a landscape a
                    bit short, providing a perfect opportunity for tree removal. Removing trees that obstruct views or
                    detract from the overall aesthetic appeal of your landscape can enhance the visual appeal of your
                    property and create a more open and inviting outdoor space.
                </ListItem>
                <ListItem>
                    <b>Construction:</b> Constructions, additions, and home renovations are often very specific to the
                    homeowner’s needs and might call for a shift in the landscape. If a tree interferes with a
                    homeowner’s blueprint for construction, tree removal would make sense. Removing trees that
                    interfere with construction projects ensures smooth progress and allows homeowners to realize
                    their vision for their property without compromising on safety or design.
                </ListItem>
            </List>

            <Text>There are a handful of reasons to remove a tree and generally, we consider it more of a last resort.
                Of course, this is one of the more complex operations and is an undertaking best done alongside a
                professional arborist. At Overland Park Tree Care, we are here to guide you through this process and
                help you make the best decisions for your trees and property.</Text>
        </Stack>
    )
}